import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { ProductModel } from 'src/app/shared/models/product.model';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {

  //form : FormGroup = ProductModel.getFormGroup();
  dialogData :any;
  listProductCategory : CategoryModel[];

  constructor(public service : ProductService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private pcservice : ProductCategoryService,
    private dialogRef: MatDialogRef<ProductDetailComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

   console.log("ProductDetailComponent");
      this.dialogData = data;

   }

  ngOnInit() {
    this.pcservice.getList().subscribe(
      res=>{
        this.listProductCategory = res as CategoryModel[];
      },
      err=>{}
      );

  }

  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("Create product");

    if (this.service.form.valid) {
      if (!this.service.form.get('productId').value){
        this.service.insertData(this.service.form.value).subscribe(
          res=>{
            //this.service.list.push(res as Customer);
             ////this.toastr.success("Submit successfuly", "Product Create");
             this.gnotify.showSnackBar('Product Create', 'Submit successfuly', "success");
             this.dialogData.result = true;
             this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Product Create");
            this.gnotify.showSnackBar('Product Create', 'Failed to Submit', "error");
            return;
          }
          );
      }
      else{
        this.service.updateData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submit successfuly", "Product Modify");
            this.gnotify.showSnackBar('Product Modify', 'Submit successfuly', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Product Modify");
            this.gnotify.showSnackBar('Product Modify', 'Failed to Submit', "error");
            return;
          }
          );

      }

    }

}
}
